/**
 * Lumière — motion engine
 * Scroll reveals, parallax, intro transition, smooth anchor scroll.
 * Vanilla JS only. Transform/opacity only for GPU-friendly motion.
 * Fully disabled when prefers-reduced-motion is set or theme setting motion_enabled is off.
 */
(function () {
  "use strict";

  var root = document.documentElement;
  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var motionEnabled = root.classList.contains("motion-enabled") && !prefersReduced;

  if (prefersReduced) root.classList.add("reduced-motion");
  if (!motionEnabled) {
    // Reveal everything immediately, skip all observers/animation work.
    document.querySelectorAll("[data-animate]").forEach(function (el) {
      el.classList.add("is-visible");
    });
    finishIntro();
    return;
  }

  var intensity = root.dataset.motionIntensity || "normal";
  var speedMap = { subtle: 0.06, normal: 0.12, cinematic: 0.2 };
  var parallaxStrength = speedMap[intensity] || 0.12;

  /* ---------------- Scroll reveal ---------------- */
  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.dataset.animateDelay || 0;
          setTimeout(function () {
            entry.target.classList.add("is-visible");
          }, delay);
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
  );

  document.querySelectorAll("[data-animate]").forEach(function (el) {
    revealObserver.observe(el);
  });

  /* ---------------- Parallax (hero + section imagery) ---------------- */
  var parallaxEls = Array.prototype.slice.call(document.querySelectorAll("[data-parallax]"));
  var ticking = false;

  function updateParallax() {
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      var progress = (rect.top - vh / 2) / vh;
      var offset = progress * 100 * parallaxStrength;
      el.style.transform = "translate3d(0," + offset.toFixed(2) + "px,0)";
    });
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  if (parallaxEls.length) {
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    updateParallax();
  }

  /* ---------------- Smooth anchor navigation ---------------- */
  document.addEventListener("click", function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute("href").slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  /* ---------------- Intro transition ---------------- */
  finishIntro();

  function finishIntro() {
    var intro = document.querySelector(".intro-transition");
    if (!intro) return;
    var reveal = function () {
      intro.classList.add("is-done");
      window.removeEventListener("load", reveal);
    };
    if (document.readyState === "complete") {
      setTimeout(reveal, 700);
    } else {
      window.addEventListener("load", function () {
        setTimeout(reveal, 700);
      });
    }
  }
})();
